import { useEffect, useState } from "react";
import { useLocale } from "../contexts/LocaleContext";
import "./styles/start.css";
import "./styles/start-color-fix.css";

const START_POPUP_SEEN_KEY = "dwikStartPopupSeen";

export function StartPage() {
  const { t } = useLocale();
  const [showStartPopup, setShowStartPopup] = useState(false);

  useEffect(() => {
    if (window.localStorage.getItem(START_POPUP_SEEN_KEY) !== "true") {
      setShowStartPopup(true);
    }
  }, []);

  const closeStartPopup = () => {
    window.localStorage.setItem(START_POPUP_SEEN_KEY, "true");
    setShowStartPopup(false);
  };

  return (
    <div style={{ display: "block" }}>
      {showStartPopup && (
        <div className="start-popup-backdrop" role="dialog" aria-modal="true" aria-labelledby="start-popup-title">
          <div className="start-popup">
            <h2 id="start-popup-title">{t("start.popup.title")}</h2>
            <p>{t("start.popup.errorHint")}</p>
            <p>{t("start.popup.suggestionsHint")}</p>
            <p className="start-popup-thanks">{t("start.popup.thanks")}</p>

            <div className="start-popup-actions">
              <button className="start-popup-button" type="button" onClick={closeStartPopup}>
                {t("start.popup.startButton")}
              </button>
              <a className="start-popup-button start-popup-button-secondary" href="/#/contact">
                {t("start.popup.contactButton")}
              </a>
            </div>

            <p className="start-popup-footer">
              <strong>{t("start.popup.footerLead")}</strong> {t("start.popup.footerText")}{" "}
              <a href="https://www.elke-schark-foundation.com" target="_blank" rel="noreferrer">
                www.elke-schark-foundation.com
              </a>{" "}
              {t("start.popup.footerSuffix")}
            </p>
            <p className="start-popup-footer">{t("start.popup.shareText")}</p>
          </div>
        </div>
      )}

      <section className="gallery-scene">
        <div className="logo-gal video-container">
          <video
            className="teaser-video"
            src="/static/img/teaser.mp4"
            title="DWIK Intro Video"
            autoPlay
            muted
            playsInline
          />
        </div>
      </section>

      <div className="content start-color-band">
        <section className="wrapper">
          <div className="row">
            <div className="col-full centered">
              <span className="special-span"><h1>{t("start.title")}</h1></span>
            </div>
          </div>
        </section>
      </div>

      <div className="start-video-actions">
        <a className="start-video-action start-video-action-primary" href="#/world">
          {t("start.createFrame")}
        </a>
        <a className="start-video-action start-video-action-secondary" href="#/video">
          {t("start.explainerVideo")}
        </a>
        <a className="start-video-action start-video-action-secondary" href="#/art-search">
          {t("artSearch.title")}
        </a>
      </div>

      <div className="content">
        <section className="wrapper">
          <div className="row">
            <div className="col-full centered">
              <h1>{t("start.colorTheWorld")}</h1>
              <h2>{t("start.subtitle")}</h2>
              <p className="centered">
                {t("start.intro")}{" "}
                <a href="https://www.mage.space" target="_blank" rel="noreferrer">
                  www.mage.space
                </a>.{" "}
                {t("start.introSuffix")}
              </p>

              <div className="grid-icons">
                <article className="card">
                  <div className="icon">
                    <i className="fa-solid fa-brush" style={{ marginLeft: 8 }} />
                  </div>
                  <h3 className="title">{t("start.card1Title")}</h3>
                  <p className="text">{t("start.card1Text")}</p>
                </article>

                <article className="card">
                  <div className="icon"><i className="fa-solid fa-bullseye" /></div>
                  <h3 className="title">{t("start.card2Title")}</h3>
                  <p className="text">{t("start.card2Text")}</p>
                </article>

                <article className="card">
                  <div className="icon"><i className="fa-solid fa-users" /></div>
                  <h3 className="title">{t("start.card3Title")}</h3>
                  <p className="text">{t("start.card3Text")}</p>
                </article>

                <article className="card">
                  <div className="icon"><i className="fa-solid fa-heart" /></div>
                  <h3 className="title">{t("start.card4Title")}</h3>
                  <p className="text">{t("start.card4Text")}</p>
                </article>

                <article className="card">
                  <div className="icon"><i className="fa-solid fa-bullhorn" /></div>
                  <h3 className="title">{t("start.card5Title")}</h3>
                  <p className="text">{t("start.card5Text")}</p>
                </article>

                <article className="card">
                  <div className="icon"><i className="fa-solid fa-earth-europe" /></div>
                  <h3 className="title">{t("start.card6Title")}</h3>
                  <p className="text">{t("start.card6Text")}</p>
                </article>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
